const ProductionProductionOrder = () => import('@/views/modules/production/ProductionOrder/ProductionOrder')
const ProductionProductionOrderInsert = () => import('@/views/modules/production/ProductionOrder/ProductionOrderInsert')
const ProductionProductionOrderStep = () => import('@/views/modules/production/ProductionOrder/ProductionOrderStep')
const ProductionProductionOrderStepForm = () => import('@/views/modules/production/ProductionOrder/ProductionOrderStepForm')
const ProductionProductionOrderBulkAction = () => import('@/views/modules/production/ProductionOrder/ProductionOrderBulkAction')
const ProductionProductionOrderBulkActionForm = () => import('@/views/modules/production/ProductionOrder/ProductionOrderBulkActionForm')
const ProductionProcessFlow = () => import('@/views/modules/production/ProcessFlow/ProcessFlow')
const ProductionProcessFlowForm = () => import('@/views/modules/production/ProcessFlow/ProcessFlowForm')
const ProductionTypeMold = () => import('@/views/modules/production/Type/TypeMold')
const ProductionTypeMoldForm = () => import('@/views/modules/production/Type/TypeMoldForm')
const ProductionTypeMaintenance = () => import('@/views/modules/production/Type/TypeMaintenance')
const ProductionTypeMaintenanceForm = () => import('@/views/modules/production/Type/TypeMaintenanceForm')
const ProductionTypeStop = () => import('@/views/modules/production/Type/TypeProductionStop')
const ProductionTypeStopForm = () => import('@/views/modules/production/Type/TypeProductionStopForm')
const ProductionTypeMachine = () => import('@/views/modules/production/Type/TypeMachine')
const ProductionTypeMachineForm = () => import('@/views/modules/production/Type/TypeMachineForm')
const ProductionMold = () => import('@/views/modules/production/Mold/Mold')
const ProductionMoldForm = () => import('@/views/modules/production/Mold/MoldForm')
const ProductionOperator = () => import('@/views/modules/production/Operator/Operator')
const ProductionOperatorForm = () => import('@/views/modules/production/Operator/OperatorForm')
const ProductionMachine = () => import('@/views/modules/production/Machine/Machine')
const ProductionMachineForm = () => import('@/views/modules/production/Machine/MachineForm')
const ProductionTypeStatusProduction = () => import('@/views/modules/production/Type/TypeStatusProduction')
const ProductionTypeStatusProductionForm = () => import('@/views/modules/production/Type/TypeStatusProductionForm')
const ProductionTypeNonConformance = () => import('@/views/modules/production/Type/TypeNonConformance')
const ProductionTypeNonConformanceForm = () => import('@/views/modules/production/Type/TypeNonConformanceForm')
const ProductionTypeRestriction = () => import('@/views/modules/production/Type/TypeRestriction')
const ProductionTypeRestrictionForm = () => import('@/views/modules/production/Type/TypeRestrictionForm')

const ProductionTypeInstrument = () => import('@/views/modules/production/Type/TypeInstrument')
const ProductionTypeInstrumentForm = () => import('@/views/modules/production/Type/TypeInstrumentForm')
const ProductionInstrument = () => import('@/views/modules/production/Instrument/Instrument')
const ProductionInstrumentForm = () => import('@/views/modules/production/Instrument/InstrumentForm')

const ProductionLot = () => import('@/views/modules/production/Lot/Lot')
const ProductionLotForm = () => import('@/views/modules/production/Lot/LotForm')
const ProductionSetting = () => import('@/views/modules/production/Setting/Setting')
const ProductionSettingParam = () => import('@/views/modules/production/Setting/SettingParam')
const ProductionSettingParamForm = () => import('@/views/modules/production/Setting/SettingParamForm')
const ProductionReport = () => import('@/views/modules/production/Report/ProductionReport')

export default [

    {
        path: '/production/order/new',
        name: 'production-order-form-new',
        component: ProductionProductionOrderInsert
    }/*, {
        path: '/production/order/view/:id',
        name: 'production-order-form-batch-view',
        component: ProductionProductionOrderBatchForm
    }, {
        path: '/production/order/remove/:id',
        name: 'production-order-form-batch-remove',
        component: ProductionProductionOrderBatchForm
    }, {
        path: '/production/order/:id',
        name: 'production-order-form-batch',
        component: ProductionProductionOrderBatchForm
    }*/
    , {path: '/production/order', name: 'production-order', component: ProductionProductionOrder}
    , {
        path: '/production/order-step/view/:id',
        name: 'production-order-step-form-view',
        component: ProductionProductionOrderStepForm
    }, {
        path: '/production/order-step/:id',
        name: 'production-order-step-form',
        component: ProductionProductionOrderStepForm
    }
    , {path: '/production/order-step', name: 'production-order-step', component: ProductionProductionOrderStep}


    , {
        path: '/production/bulk-action/new',
        name: 'production-bulk-action-form-new',
        component: ProductionProductionOrderBulkActionForm
    }, {
        path: '/production/bulk-action/view/:id',
        name: 'production-bulk-action-form-view',
        component: ProductionProductionOrderBulkActionForm
    }, {
        path: '/production/bulk-action/remove/:id',
        name: 'production-bulk-action-form-remove',
        component: ProductionProductionOrderBulkActionForm
    }, {
        path: '/production/bulk-action/:id',
        name: 'production-bulk-action-form',
        component: ProductionProductionOrderBulkActionForm
    }
    , {path: '/production/bulk-action', name: 'production-bulk-action', component: ProductionProductionOrderBulkAction}


    , {
        path: '/production/process-flow/new',
        name: 'production-process-flow-form-new',
        component: ProductionProcessFlowForm
    }, {
        path: '/production/process-flow/view/:id',
        name: 'production-process-flow-form-view',
        component: ProductionProcessFlowForm
    }, {
        path: '/production/process-flow/remove/:id',
        name: 'production-process-flow-form-remove',
        component: ProductionProcessFlowForm
    }, {
        path: '/production/process-flow/:id',
        name: 'production-process-flow-form',
        component: ProductionProcessFlowForm
    }
    , {path: '/production/process-flow', name: 'production-process-flow', component: ProductionProcessFlow}


    , {path: '/production/setting', name: 'production-setting', component: ProductionSetting},

    {
        path: '/production/setting/param/view/:id',
        name: 'production-setting-param-form-view',
        component: ProductionSettingParamForm
    },
    {
        path: '/production/setting/param/:id',
        name: 'production-setting-param-form-',
        component: ProductionSettingParamForm
    }

    , {path: '/production/setting/param', name: 'production-setting-param', component: ProductionSettingParam}


    , {path: '/production/report', name: 'production-report', component: ProductionReport}

    , {
        path: '/production/mold/new',
        name: 'production-mold-form-new',
        component: ProductionMoldForm
    }, {
        path: '/production/mold/view/:id',
        name: 'production-mold-form-view',
        component: ProductionMoldForm
    }, {
        path: '/production/mold/remove/:id',
        name: 'production-mold-form-remove',
        component: ProductionMoldForm
    }, {
        path: '/production/mold/:id',
        name: 'production-mold-form',
        component: ProductionMoldForm
    }
    , {path: '/production/mold', name: 'production-mold', component: ProductionMold}

    , {
        path: '/production/type-mold/new',
        name: 'production-type-mold-form-new',
        component: ProductionTypeMoldForm
    }, {
        path: '/production/type-mold/view/:id',
        name: 'production-type-mold-form-view',
        component: ProductionTypeMoldForm
    }, {
        path: '/production/type-mold/remove/:id',
        name: 'production-type-mold-form-remove',
        component: ProductionTypeMoldForm
    }, {
        path: '/production/type-mold/:id',
        name: 'production-type-mold-form',
        component: ProductionTypeMoldForm
    }
    , {path: '/production/type-mold', name: 'production-type-mold', component: ProductionTypeMold}

    , {
        path: '/production/type-maintenance/new',
        name: 'production-type-maintenance-form-new',
        component: ProductionTypeMaintenanceForm
    }, {
        path: '/production/type-maintenance/view/:id',
        name: 'production-type-maintenance-form-view',
        component: ProductionTypeMaintenanceForm
    }, {
        path: '/production/type-maintenance/remove/:id',
        name: 'production-type-maintenance-form-remove',
        component: ProductionTypeMaintenanceForm
    }, {
        path: '/production/type-maintenance/:id',
        name: 'production-type-maintenance-form',
        component: ProductionTypeMaintenanceForm
    }
    , {
        path: '/production/type-maintenance',
        name: 'production-type-maintenance',
        component: ProductionTypeMaintenance
    }

    , {
        path: '/production/type-stop/new',
        name: 'production-type-stop-form-new',
        component: ProductionTypeStopForm
    }, {
        path: '/production/type-stop/view/:id',
        name: 'production-type-stop-form-view',
        component: ProductionTypeStopForm
    }, {
        path: '/production/type-stop/remove/:id',
        name: 'production-type-stop-form-remove',
        component: ProductionTypeStopForm
    }, {
        path: '/production/type-stop/:id',
        name: 'production-type-stop-form',
        component: ProductionTypeStopForm
    }
    , {
        path: '/production/type-stop',
        name: 'production-type-stop',
        component: ProductionTypeStop
    }

    , {
        path: '/production/type-machine/new',
        name: 'production-type-machine-form-new',
        component: ProductionTypeMachineForm
    }, {
        path: '/production/type-machine/view/:id',
        name: 'production-type-machine-form-view',
        component: ProductionTypeMachineForm
    }, {
        path: '/production/type-machine/remove/:id',
        name: 'production-type-machine-form-remove',
        component: ProductionTypeMachineForm
    }, {
        path: '/production/type-machine/:id',
        name: 'production-type-machine-form',
        component: ProductionTypeMachineForm
    }
    , {path: '/production/type-machine', name: 'production-type-machine', component: ProductionTypeMachine}

    , {
        path: '/production/operator/new',
        name: 'production-operator-form-new',
        component: ProductionOperatorForm
    }, {
        path: '/production/operator/view/:id',
        name: 'production-operator-form-view',
        component: ProductionOperatorForm
    }, {
        path: '/production/operator/remove/:id',
        name: 'production-operator-form-remove',
        component: ProductionOperatorForm
    }, {
        path: '/production/operator/:id',
        name: 'production-operator-form',
        component: ProductionOperatorForm
    }
    , {path: '/production/operator', name: 'production-operator', component: ProductionOperator}

    , {
        path: '/production/machine/new',
        name: 'production-machine-form-new',
        component: ProductionMachineForm
    }, {
        path: '/production/machine/view/:id',
        name: 'production-machine-form-view',
        component: ProductionMachineForm
    }, {
        path: '/production/machine/remove/:id',
        name: 'production-machine-form-remove',
        component: ProductionMachineForm
    }, {
        path: '/production/machine/:id',
        name: 'production-machine-form',
        component: ProductionMachineForm
    }
    , {path: '/production/machine', name: 'production-machine', component: ProductionMachine}


    , {
        path: '/production/type-status/new',
        name: 'production-type-status-form-new',
        component: ProductionTypeStatusProductionForm
    }, {
        path: '/production/type-status/view/:id',
        name: 'production-type-status-form-view',
        component: ProductionTypeStatusProductionForm
    }, {
        path: '/production/type-status/remove/:id',
        name: 'production-type-status-form-remove',
        component: ProductionTypeStatusProductionForm
    }, {
        path: '/production/type-status/:id',
        name: 'production-type-status-form',
        component: ProductionTypeStatusProductionForm
    }
    , {
        path: '/production/type-status',
        name: 'production-type-status',
        component: ProductionTypeStatusProduction
    }, {
        path: '/production/type-non-conformance/new',
        name: 'production-type-non-conformance-form-new',
        component: ProductionTypeNonConformanceForm
    }, {
        path: '/production/type-non-conformance/view/:id',
        name: 'production-type-non-conformance-form-view',
        component: ProductionTypeNonConformanceForm
    }, {
        path: '/production/type-non-conformance/remove/:id',
        name: 'production-type-non-conformance-form-remove',
        component: ProductionTypeNonConformanceForm
    }, {
        path: '/production/type-non-conformance/:id',
        name: 'production-type-non-conformance-form',
        component: ProductionTypeNonConformanceForm
    }
    , {
        path: '/production/type-non-conformance',
        name: 'production-type-non-conformance',
        component: ProductionTypeNonConformance
    }, {
        path: '/production/type-restriction/new',
        name: 'production-type-restriction-form-new',
        component: ProductionTypeRestrictionForm
    }, {
        path: '/production/type-restriction/view/:id',
        name: 'production-type-restriction-form-view',
        component: ProductionTypeRestrictionForm
    }, {
        path: '/production/type-restriction/remove/:id',
        name: 'production-type-restriction-form-remove',
        component: ProductionTypeRestrictionForm
    }, {
        path: '/production/type-restriction/:id',
        name: 'production-type-restriction-form',
        component: ProductionTypeRestrictionForm
    }
    , {path: '/production/type-restriction', name: 'production-type-restriction', component: ProductionTypeRestriction}


    , {
        path: '/production/type-instrument/new',
        name: 'production-type-instrument-form-new',
        component: ProductionTypeInstrumentForm
    }, {
        path: '/production/type-instrument/view/:id',
        name: 'production-type-instrument-form-view',
        component: ProductionTypeInstrumentForm
    }, {
        path: '/production/type-instrument/remove/:id',
        name: 'production-type-instrument-form-remove',
        component: ProductionTypeInstrumentForm
    }, {
        path: '/production/type-instrument/:id',
        name: 'production-type-instrument-form',
        component: ProductionTypeInstrumentForm
    }
    , {path: '/production/type-instrument', name: 'production-type-instrument', component: ProductionTypeInstrument}

    , {
        path: '/production/instrument/new',
        name: 'production-instrument-form-new',
        component: ProductionInstrumentForm
    }, {
        path: '/production/instrument/view/:id',
        name: 'production-instrument-form-view',
        component: ProductionInstrumentForm
    }, {
        path: '/production/instrument/remove/:id',
        name: 'production-instrument-form-remove',
        component: ProductionInstrumentForm
    }, {
        path: '/production/instrument/:id',
        name: 'production-instrument-form',
        component: ProductionInstrumentForm
    }
    , {path: '/production/instrument', name: 'production-instrument', component: ProductionInstrument}

    , {
        path: '/production/lot/new',
        name: 'production-lot-form-new',
        component: ProductionLotForm
    }, {
        path: '/production/lot/view/:id',
        name: 'production-lot-form-view',
        component: ProductionLotForm
    }, {
        path: '/production/lot/remove/:id',
        name: 'production-lot-form-remove',
        component: ProductionLotForm
    }, {
        path: '/production/lot/:id',
        name: 'production-lot-form',
        component: ProductionLotForm
    }
    , {path: '/production/lot', name: 'production-lot', component: ProductionLot}
]